'use client';
import cn from 'clsx';
import styles from '../reviews.module.scss';

import { useState } from 'react';
import UKToast from '@/components/UKToast/index';
import { HelpfulProps } from '@/app/csr-src/apis/profile/review.interface';
import { handleHelpfulOperation } from '@/app/csr-src/apis/profile/review.api';
import { sendClickTrack as myReviewSendClickTrack } from '@/tracks/25155';
import { useTranslation } from '@/i18n/client';
import { useStores } from '@/models';
import ZanIcon from '@/assets/icons/zan.svg';
import UKMaskLoading from '@/components/UKMaskLoading';

interface HelpProps {
  data: HelpfulProps;
  pageType?: string;
  expConfig?: any;
}
export default function HelpfulButton({ data, pageType, expConfig }: HelpProps) {
  const { t } = useTranslation();
  const { commentOpstsStore } = useStores();
  const { helpfulNum, commentId, currentIsHelp } = data || {};
  const [helpNum, setHelpNum] = useState<string>(helpfulNum || '0');
  const [helpfulState, setHelpfulState] = useState<boolean>(currentIsHelp);

  const onHandle = async (event: React.MouseEvent) => {
    UKMaskLoading.show();
    const res = await handleHelpfulOperation({
      commentId: commentId,
      operation: helpfulState ? 2 : 1,
    });
    if (res?.data?.result) {
      setHelpfulState(!helpfulState);
      const { likeCount } = res?.data || {};
      setHelpNum(likeCount !== '0' ? likeCount || '0' : '0');
      commentOpstsStore.changeHelpState(commentId, {
        helpfulState: !helpfulState,
        helpfulNum: likeCount,
      });
    } else {
      UKToast.show({
        icon: 'error',
        content: res?.msg || t('common.message.tryAgain'),
      });
    }
    UKMaskLoading.close();
    event.preventDefault();
  };

  const onHelpfulChange = (newCommentId: string, newValue: any) => {
    if (newCommentId === commentId) {
      setHelpNum(newValue.helpfulNum || '0');
      setHelpfulState(newValue.helpfulState);
    }
  };

  commentOpstsStore.onHelpfulChange(onHelpfulChange);

  return (
    <div
      className={cn(styles.helpfulBtn, helpfulState ? styles.active : '')}
      exptag={expConfig?.help?.expTag}
      data-exptag-json-param={JSON.stringify(expConfig?.help?.data)}
      data-exptag-config={expConfig?.help?.config}
      onClick={(e: any) => {
        /** 点击事件上报-已完成评价tab下按钮点击 */
        switch (pageType) {
          case 'reviewComment':
            // {"button_name":"1-helpful，2-comment，3-more","commentId":""}
            myReviewSendClickTrack.My_Reviews_Completed_Btn({
              button_name: '1',
              commentId: `${commentId}`,
            });
            break;

          default:
            break;
        }
        onHandle?.(e);
      }}
    >
      {/* <i className={cn(styles.zanIcon, styles.mar)}></i> */}
      <ZanIcon className={cn(styles.zanIcon, styles.mar)} />
      {`${t('dp.commentSection.helpful')}`}<span className={styles.space}>{helpNum !== '0' ? '(' + helpNum + ')' : ''}</span>
    </div>
  );
}
